import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Chip } from "../Chip/chip";
import "./ChipFilter.css"

export const ChipFilter = ({
    id,
    className,
    options = [],
    value = [],
    onChange = () => {},
}) => {
    return (
        <div className={clsx("chip-filter-root", className)}>
            {options.map((opt) => (
                <Chip
                key={opt.value}
                label={opt.label}
                value={opt.value}
                active={value.includes(opt.value)}
                onClick={() => onChange(id, opt.value)}
                />
            ))}
        </div>
    );
};

ChipFilter.propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    value: PropTypes.array,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOf([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    onChange: PropTypes.func,
};
